module.exports = __webpack_public_path__ + "static/media/pageLogo.aa5727c9.png";